/**
 * Real-time chat contract shared between the API (publisher) and the web
 * client (consumer). The Socket.IO server emits a single `VendorChannelBroadcast`
 * event whose `eventType` discriminates the payload — this union is the source
 * of truth for that shape so a renamed event or a dropped field surfaces as a
 * compile error instead of a silent no-op.
 *
 * Date-shaped fields are typed `string | Date`: tRPC responses carry real
 * `Date`s (superjson transformer) while Socket.IO payloads are plain JSON and
 * arrive as ISO strings. Consumers should normalise with `new Date(value)`,
 * which accepts both.
 */
/** The Socket.IO event name every broadcast is delivered under. */
export const VENDOR_CHANNEL_BROADCAST = 'VendorChannelBroadcast';
